import Vue from 'vue'

const Brands = {
  namespaced: true,

  state: {
    brand: { image: null },
    brandName: null,
    ebuyclubPartner: {},
    brands: []
  },

  mutations: {
    setBrands(state, brands) {
      state.brands = brands || []
    },
    setBrand(state, brand) {
      state.brand = brand || { image: null }
      state.brandName = state.brand.name
    },
    setEbuyclubPartner(state, ebuyclubPartner) {
      state.ebuyclubPartner = ebuyclubPartner || {}
    }
  },

  actions: {
    async getAll({ commit }, { search } = {}) {
      const params = { search }
      const response = await Vue.axios.get('/brands', { params })
      const brands = response.data.data
      commit('setBrands', brands)
      return brands
    },
    async get({ commit }, id) {
      let brand = { image: null }
      if (id) {
        const response = await Vue.axios.get(`/brand/${id}`)
        brand = response.data.data
      }
      commit('setBrand', brand)
      return brand
    },
    async getEbuyclubPartner({ commit }, id) {
      let ebuyclubPartner = {}
      if (id) {
        try {
          const response = await Vue.axios.get(`/brand/${id}/ebuyclub-partner`)
          ebuyclubPartner = response.data.data
        } catch (err) { /* do nothing */ }
      }
      commit('setEbuyclubPartner', ebuyclubPartner)
      return ebuyclubPartner
    },
    async createAndSet({ dispatch }, { name, item }) {
      const response = await Vue.axios.post('/brand', { name })
      const { id } = response.data.data
      await dispatch('getAll')
      item.brand_id = id
    },
    async createOrUpdate({ commit, state }) {
      let response
      if (state.brand.id) {
        response = await Vue.axios.put(`/brand/${state.brand.id}`, state.brand)
      } else {
        response = await Vue.axios.post('/brand', state.brand)
      }
      commit('setBrand', response.data.data)
    }
  }
}

export default Brands
